import { HeroCTA } from '../HeroCTA'
import { HeroDualImageTiles } from './HeroDualImageTiles'
import { HeroSingleImageTile } from './HeroSingleImageTile'

interface HeroMobileProps {
  heading: string
  subheading: string
  img1Url: string
  img1Alt?: string
  img2Url?: string
  img2Alt?: string
}

export const HeroMobile = ({
  heading,
  subheading,
  img1Url,
  img1Alt = '',
  img2Url,
  img2Alt = '',
}: HeroMobileProps) => (
  <section className='d-lg-none mc-mb-8'>
    {img1Url && img2Url ? (
      <HeroDualImageTiles
        img1Url={img1Url}
        img1Alt={img1Alt}
        img2Url={img2Url}
        img2Alt={img2Alt}
      />
    ) : (
      <HeroSingleImageTile imgUrl={img1Url} imgAlt={img1Alt} />
    )}
    <div className='container'>
      <h1 className='mc-mb-8 mc-text-d3 mc-text--brand mc-text--uppercase mc-text--center'>
        {heading}
      </h1>
      <p className='mc-text-h4 mc-mb-8 mc-text--center'>{subheading}</p>
      <HeroCTA outcomeName={heading} fullWidth />
    </div>
  </section>
)
